let assetsUrl = process.env.IMPORT_META_URL
  ? String(process.env.IMPORT_META_URL).replace(/\/modules.*/, "")
  : "/ui";

export function getAssetsUrl() {
  return assetsUrl;
}

export function setAssetsUrl(url: string) {
  assetsUrl = url;
}
